module.exports = __webpack_public_path__ + "static/media/kitchen-re-fit_01.eb0f6b44.png";